export default "__VITE_ASSET__BEJcLWi7__ 100w";